<div class="hero">
	<div class="hero-body">
		<div class="container">
			<p class="blue has-text-centered is-size-5 column is-two-thirds page-description">
				Nuestras acreditaciones respaldan todos nuestros servicios. Estamos capacitados para ofrecerte nuestra gama de servicios en toda la república.
			</p>
			<div class="columns is-mobile is-multiline has-text-centered">
				<ng-container *ngFor="let cert of accreditations">
					<div class="column is-one-quarter-widescreen is-half-mobile is-one-third-tablet">
						<a [href]="cert.mainUrl" target="_blank">
							<img [src]="cert.mainThumbnailUrl" />
						</a>
						<h4 class="title blue is-4 is-marginless">{{ cert.mainViewTitle }}</h4>
						<a [href]="cert.mainTableUrl" class="has-text-centered is-uppercase red table-link">Tabla CMC</a>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>